import httpClient from '@/services/httpClient'
import {AxiosResponse} from 'axios'
import {
  AxiosResponseDashboardInterface,
  NotificationInterface,
  SubscriptionPlanInterface,
  SubscriptionStatusItem,
  TransactionInterface,
  TransactionListItem,
  UserWithBalanceInterface,
} from '@/types/types'
import {TRANSACTION_CONTENT_ENUM, TRANSACTION_TYPE_ENUM} from '@/types/enums'

const UserService = {
  getUser: (): Promise<AxiosResponse<UserWithBalanceInterface>> =>
    httpClient.get('/profile/'),
  editProfile: (data: {
    language?: string
    email?: string
    username?: string
    wallet?: string
    referral_code?: string
    referral_link?: string
  }): Promise<AxiosResponse<UserWithBalanceInterface>> =>
    httpClient.put('/profile/', data),
  sendLandsCode: (code: string) => httpClient.post('/lands/buy/code', {code}),
  getTransactions: (
    page: number,
    pageSize: number,
    periodFrom: Date,
    periodTo: Date,
    type: TRANSACTION_TYPE_ENUM,
    obj_type: TRANSACTION_CONTENT_ENUM
  ): Promise<AxiosResponse<{transactions: TransactionInterface[]}>> => {
    const data = {page, period_from: periodFrom, period_to: periodTo}
    if (obj_type !== 'ALL') {
      // @ts-ignore
      data['obj_type'] = obj_type
    }

    if (type !== 'ALL') {
      // @ts-ignore
      data['type'] = type
    }

    return httpClient.get('/transactions/', {
      params: data,
    })
  },

  getTransactionList: (
    startDate?: string,
    endDate?: string
  ): Promise<AxiosResponse<{transactions: TransactionListItem[]}>> => {
    const params: {start_date?: string; end_date?: string} = {}
    if (startDate) params.start_date = startDate
    if (endDate) params.end_date = endDate
    return httpClient.get('/transaction-list', {params})
  },
  getDashboard: (): Promise<AxiosResponse<AxiosResponseDashboardInterface>> =>
    httpClient.get('/profile/dashboard'),
  getNotifications: (
    page_size: number,
    paging_state?: string | null
  ): Promise<
    AxiosResponse<{
      notifications: NotificationInterface[]
      next_paging_state: string | null
      unread_count: number
    }>
  > =>
    httpClient.get('/users/notifications', {
      params: {page_size, paging_state},
    }),
  readNotifications: (data: {
    mark_all_as_read?: boolean
    ids?: string[]
  }): Promise<
    AxiosResponse<{
      status: true
    }>
  > => httpClient.put('/users/notifications', data),
  checkWork: (): Promise<
    AxiosResponse<{
      status: true
    }>
  > => httpClient.get('/system-health/'),
  getLeaderboard: (): Promise<
    AxiosResponse<{
      [key: string]: {username: string; lands_all_time: number}
    }>
  > => httpClient.get('/profile/leaderboard'),
  getLocalization: (): Promise<
    AxiosResponse<{
      [key: string]: {}
    }>
  > => httpClient.get('/localization'),
  getSubscriptions: (): Promise<
    AxiosResponse<{
      status: boolean
      subscriptions: SubscriptionStatusItem[]
    }>
  > => httpClient.get('/store/subscription'),
  subscribe: (
    type: number,
    price: number,
    subscriptionId?: number
  ): Promise<
    AxiosResponse<{
      [key: string]: {}
    }>
  > =>
    httpClient.post('/store/subscription', {
      type,
      price,
      ...(subscriptionId !== undefined && {subscription_id: subscriptionId}),
    }),
  getSubscriptionPlans: (): Promise<
    AxiosResponse<{list: SubscriptionPlanInterface[]}>
  > => httpClient.get('/store/subscription/list'),
}

export default UserService
